import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import HotMovies from './components/HotMovies';
import CategorySection from './components/CategorySection';
import LatestUpdates from './components/LatestUpdates';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <HotMovies />
        <CategorySection />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}